import { withData } from "../decorators/with-data"
import gql from "graphql-tag"
import { getSecondaryClient } from '../data/client'

const QUERY = gql`
  query ImprovementProjectQuery(
    $surveyId: UUID!
  ) {
    improvementProject(surveyId: $surveyId) {
      id
      phase
    }
  }
`

export const withImprovementProjectData = withData(QUERY, {
  options: ({
    match: {
      params: { surveyId }
    }
  }) => ({
    variables: { surveyId },
    client: getSecondaryClient()
  }),
  props: ({ data }) => ({
    improvementProject: data.improvementProject
  })
})



// WEBPACK FOOTER //
// ./src/containers/withImprovementProjectData.js